import React from "react";
// import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";

const ProjectAreaOne = () => {
  return (
    <div className="project-section project-section_1 py-3 ">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="section-title text-center">
              <h6 className="sub-title">Gallery Here</h6>
              <h2 className="title">
                Latest <span>Projects</span> Are Here
              </h2>
            </div>
          </div>
        </div>
        {/* <nav className="text-center">
          <div
            className="nav nav-tabs project-nav-tab d-inline-flex mb-5"
            id="nav-tab"
            role="tablist"
          >
            <button
              className="nav-link active"
              id="nav-tabs1-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-tabs1"
              type="button"
              role="tab"
              aria-controls="nav-tabs1"
              aria-selected="true"
            >
              View All
            </button>
            <button
              className="nav-link"
              id="nav-tabs2-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-tabs2"
              type="button"
              role="tab"
              aria-controls="nav-tabs2"
              aria-selected="false"
            >
              Softwate
            </button>
            <button
              className="nav-link"
              id="nav-tabs3-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-tabs3"
              type="button"
              role="tab"
              aria-controls="nav-tabs3"
              aria-selected="false"
            >
              New Project
            </button>
            <button
              className="nav-link"
              id="nav-tabs4-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-tabs4"
              type="button"
              role="tab"
              aria-controls="nav-tabs4"
              aria-selected="false"
            >
              Digitals
            </button>
            <button
              className="nav-link"
              id="nav-tabs5-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-tabs5"
              type="button"
              role="tab"
              aria-controls="nav-tabs5"
              aria-selected="false"
            >
              Hardware
            </button>
          </div>
        </nav> */}
        <div className="tab-content" id="nav-tabContent">
          <div
            className="tab-pane fade show active"
            id="nav-tabs1"
            role="tabpanel"
            aria-labelledby="nav-tabs1-tab"
          >
            <div className="row">
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/portfolio/project2.PNG" alt="img" />
                  <div className="details">
                    {/* <span>
                      <FaPlus />
                    </span> */}
                    <Link
                      className="read-more-text"
                      target="_blank"
                      to="https://wallpapercast.com/"
                    >
                      VIEW PROJECT
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/portfolio/project8.PNG" alt="img" />
                  <div className="details">
                    {/* <span>
                      <FaPlus />
                    </span> */}
                    <Link
                      className="read-more-text"
                      target="_blank"
                      to="https://ehya.com.pk/"
                    >
                      VIEW PROJECT
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div
            className="tab-pane fade"
            id="nav-tabs2"
            role="tabpanel"
            aria-labelledby="nav-tabs2-tab"
          >
            <div className="row">
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/portfolio/project9.PNG" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/5.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/6.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/img/gallery/3.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/4.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/8.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/img/gallery/2.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/7.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div
            className="tab-pane fade"
            id="nav-tabs3"
            role="tabpanel"
            aria-labelledby="nav-tabs3-tab"
          >
            <div className="row">
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/img/gallery/1.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/5.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/6.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/img/gallery/2.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/7.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/img/gallery/3.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/4.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/8.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-tabs4"
            role="tabpanel"
            aria-labelledby="nav-tabs4-tab"
          >
            <div className="row">
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/img/gallery/2.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/7.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/img/gallery/3.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/4.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/8.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/img/gallery/1.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/5.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/6.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="tab-pane fade"
            id="nav-tabs5"
            role="tabpanel"
            aria-labelledby="nav-tabs5-tab"
          >
            <div className="row">
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/img/gallery/1.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/5.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/6.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/img/gallery/2.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/7.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="single-project-inner">
                  <img src="assets/img/gallery/3.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/4.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
                <div className="single-project-inner">
                  <img src="assets/img/gallery/8.png" alt="img" />
                  <div className="details">
                    <span>
                      <FaPlus />
                    </span>
                    <Link className="read-more-text" to="#">
                      MORE PROJECT
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ProjectAreaOne;
